import React, { FC, useContext, useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { FORM_FIELDS, FORM_STEPS } from '../../../../../constants';
import {
    AdditionalPhoneField,
    AdditionalPhoneOwnerField,
    AdditionalPhoneOwnerFioField,
    EducationField,
    EmailField,
    FamilyStatusField,
    NumberOfDependentsField,
    RegistrationApartmentField,
    RegistrationDateField,
    RegistrationStreetField,
    ResidenceApartmentField,
    ResidenceStreetField,
} from './fields';
import { ADDITIONAL_PHONE_OWNER_DEPS } from '../../../../../constants/field.dependencies';
import { SheetContent, SheetFooter, SheetHeader } from '../../components/form/components/focused.sheet';
import { StepContext } from '../../../creator/step.context';

export const PersonalDataStepSheetView: FC = React.memo(() => {
    const form = useFormContext();
    const { currentStepConfig, currentStep, setFocusedField, focusedField } = useContext(StepContext);
    const {
        watch,
        formState: { dirtyFields: _ },
    } = form;

    useEffect(() => {
        if (currentStepConfig.stepName === FORM_STEPS.PERSONAL_DATA && focusedField) {
            setFocusedField(FORM_FIELDS.REGISTRATION_STREET);
        }
    }, [currentStep]);

    const [addressesAreEqual, additionalPhoneOwner] = watch([
        FORM_FIELDS.RESIDENCE_SAME_REGISTRATION,
        FORM_FIELDS.ADDITIONAL_PHONE_OWNER,
    ]);

    const additionalPhoneFields = useMemo(
        () => ADDITIONAL_PHONE_OWNER_DEPS[additionalPhoneOwner] || [],
        [additionalPhoneOwner],
    );

    const fieldsList = useMemo(() => {
        const residenceFields = !addressesAreEqual
            ? [
                  { name: FORM_FIELDS.RESIDENCE_STREET, view: ResidenceStreetField },
                  { name: FORM_FIELDS.RESIDENCE_APARTMENT, view: ResidenceApartmentField },
              ]
            : [];

        const additionalPhoneField = additionalPhoneFields.includes(FORM_FIELDS.ADDITIONAL_PHONE_OWNER_FIO)
            ? [{ name: FORM_FIELDS.ADDITIONAL_PHONE_OWNER_FIO, view: AdditionalPhoneOwnerFioField }]
            : [];

        return [
            { name: FORM_FIELDS.REGISTRATION_STREET, view: RegistrationStreetField },
            { name: FORM_FIELDS.REGISTRATION_APARTMENT, view: RegistrationApartmentField },
            { name: FORM_FIELDS.REGISTRATION_DATE, view: RegistrationDateField },
            ...residenceFields,
            { name: FORM_FIELDS.EDUCATION, view: EducationField },
            { name: FORM_FIELDS.FAMILY_STATUS, view: FamilyStatusField },
            { name: FORM_FIELDS.NUMBER_OF_DEPENDENTS, view: NumberOfDependentsField },
            { name: FORM_FIELDS.EMAIL, view: EmailField },
            { name: FORM_FIELDS.ADDITIONAL_PHONE_OWNER, view: AdditionalPhoneOwnerField },
            { name: FORM_FIELDS.ADDITIONAL_PHONE, view: AdditionalPhoneField },
            ...additionalPhoneField,
        ];
    }, [additionalPhoneFields, addressesAreEqual]);

    return (
        <>
            <SheetHeader />
            <SheetContent fieldsList={fieldsList} />
            <SheetFooter fieldsList={fieldsList} />
        </>
    );
});

PersonalDataStepSheetView.displayName = 'PersonalDataStepSheetView';
